// Module
var code = `<!-- blHeading level 3 — see bl-heading-2.tmpl.html for rationale. -->
<h3 id="{{headingId}}">{{text}}</h3>
`;
// Exports
module.exports = code;